import { AppDispatch, createAction } from '@reduxjs/toolkit';
import { IRemindersActions } from '../../../types/filters/reminders';

export const CHANGE_REMINDERS_FILTERS = createAction<IRemindersActions, string>('reminders/CHANGE_REMINDERS_FILTERS');

export const changeReminderFilters = (reminderFilter: IRemindersActions) => (dispatch: AppDispatch) => {
  dispatch(CHANGE_REMINDERS_FILTERS(reminderFilter));
};
